import React from 'react';

import { UI_KIT_HEADER_TYPOGRAPHY } from '../../constants';
import { H1 } from '../../header-text/header-text';

import './showcase-lesson-teaser-card__title.scss';

interface Props {
    text?: string;
}

export const ShowcaseLessonTeaserCardTitle = ({ text }: Props) => {
    if (!text) {
        return null;
    }

    return (
        <H1 mix="showcase-lesson-teaser-card__title" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}>
            {text}
        </H1>
    );
};
